import React from "react";
import { Classes as BpClasses } from "@blueprintjs/core";
import { IContentPartProps} from "../../models";
import { getAlignmentClass } from "../../models/utils";
import classnames from "classnames";
import css from "../../form.module.scss";
import MergedContent from "./MergedContent";


type IProps = IContentPartProps;

const ContentPart = (props : IProps) => {
  const alignmentClass = getAlignmentClass(props.alignment);
  const className = classnames(css.formPart, alignmentClass, BpClasses.RUNNING_TEXT);

  const paragraphs = props.content.map((line, index) => (
    <MergedContent content={line} key={index}>
      {
        (content) => <div className={css.paragraph}>{content}</div>
      }
    </MergedContent>));

  const style: React.CSSProperties = {flexDirection: 'column', ...props.style}
  return (
    <div style={style} className={className}>
      {paragraphs}
    </div>);
}

export default ContentPart;






